import * as constAction from 'root/actionConstants';

/**
 * Setea un campo o el reducer completo del componente con el default.
 * @param {string} value Nombre del campo a limpiar ("all" para todo el reducer).
 * @returns {Object}
 */
export const clear = value => ({
  type: constAction.RUTINAS_CLEAR,
  payload: value,
});

/**
 * Setea un campo en el reducer .
 * @param {Object} values - Campos a setear.
 * @param {string} values.* - Nombre y valor del campo a setear.
 * @returns {Object}
 */
export const setState = values => ({
  type: constAction.RUTINAS_SET_STATE,
  payload: values,
});

/**
 * Trae la lista de rutinas .
 * @returns {Object}
 */
export const get = () => ({
  type: constAction.RUTINAS_GET,
  payload: {
    trayectos: true,
  },
  epic: {
    url: 'rutinas/getAll',
    method: 'GET',
  },
});

/**
 * Inserta/modifica el item en la lista de rutinas .
 * @param {Object} result - Respuesta del servidor(rutina creada).
 * @returns {Object}
 */
export const actualizarState = result => ({
  type: constAction.RUTINAS_LISTA_SET,
  payload: result,
});

/**
 * Trae una rutina por su ID.
 * @param {Object} id - ID de la rutina.
 * @returns {Object}
 */
export const getById = id => ({
  type: constAction.RUTINAS_GET_BY_ID,
  epic: {
    url: 'rutinas/' + id,
    method: 'GET',
  },
});

/**
 * Guarda/Modifica una rutina.
 * @param {Object} data - datos a enviar.
 * @param {Object} [id] - ID de la rutina.
 * @returns {Object}
 */
export const set = (data, id) => ({
  type: constAction.RUTINAS_SET,
  payload: {
    ...data,
  },
  epic: {
    url: id != 'new' ? 'rutinas/' + id : 'rutinas',
    method: id != 'new' ? 'PATCH' : 'POST',
  },
});

/**
 * Elimina una rutina.
 * @param {Object} id - ID de la rutina.
 * @returns {Object}
 */
export const delete_ = id => ({
  type: constAction.RUTINAS_DELETE,
  state: {
    id,
  },
  epic: {
    url: 'rutinas/' + id,
    method: 'DELETE',
  },
});

//-- ACCIONES DE OTROS COMPONENTES--//
/**
 * Trae la lista de paradas .
 * @returns {Object}
 */
export const getParadas = () => ({
  type: constAction.RUTINAS_PARADAS_GET,
  payload: {
    filter: {
      where: {
        eliminada: false,
      },
    },
  },
  epic: {
    url: 'paradas',
    method: 'GET',
  },
});

export const setGrupo = (grupoId, agregar) => ({
  type: constAction.RUTINAS_SET_GRUPOS,
  payload: { grupoId, agregar },
});

export const aplicarGruposAViajes = (rutinaId, grupos) => ({
  type: constAction.RUTINAS_SET_GRUPOS_A_VIAJES,
  payload: { rutinaId, grupos },
  epic: {
    url: 'rutinas/aplicarGruposAViajes',
    method: 'POST',
  },
});

export const aplicarCambiosAViajes = data => ({
  type: constAction.RUTINAS_SET_CAMBIOS_A_VIAJES,
  payload: data,
  epic: {
    url: 'rutinas/aplicarCambiosAViajes',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/rutinas/action.js